/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  UserListsService,
  IActivityListsMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  GraphService,
  IGraphMethods
} from "./components";

export type ActivityPageAgent = 
  IActivityListsMethods  & IStaticPageContentMethods & IGraphMethods

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    // new HeaderService(),
    // new SettingsService(),
    new UserListsService(),
    new GraphService(),
    // new InviteUserService(),
    // new DeleteUserService(),
    // new ReInviteUserService(),
    // new SuspendUserService(),
    // new ActivateUserService(),
  ];
};

export const getAgent = () => {
  return createAgent<ActivityPageAgent>({
    plugins: getPlugins(),
  });
};
